import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { getBaseUrl, getAbsoluteUrl } from "../../helpers/canonicalUrl";

class Meta extends Component {
  render() {
    const {
      seotitle = "",
      seodescription = "",
      ogtitle = "",
      ogdescription = "",
      ogimg = "",
      ogurl = "",
      ogtype = "website",
      twittertitle = "",
      twitterdescription = "",
      canonicalUrl = "",
      lang = localStorage.getItem("language") || "en",
      robots = "index, follow",
      keywords = "",
      author = "",
      publisher = localStorage.getItem("storeName") || "",
      structuredData = null,
      preconnectUrls = [],
      ogImageWidth = "",
      ogImageHeight = "",
      articleAuthor = "",
      articlePublishedTime = "",
      articleModifiedTime = ""
    } = this.props;

    const baseUrl = getBaseUrl();
    const storeName = localStorage.getItem("storeName") || "";
    const twitterUsername = localStorage.getItem("twitterUsername") || "";
    
    // Detect staging/test environment - prevent indexing
    const isStaging = typeof window !== 'undefined' && (
      window.location.hostname.includes('staging') ||
      window.location.hostname.includes('test') ||
      window.location.hostname.includes('dev') ||
      window.location.hostname.includes('localhost') ||
      window.location.hostname.includes('127.0.0.1') ||
      window.location.hostname.includes('.local') ||
      window.location.hostname.includes('hostingersite.com') // Your staging domain
    );
    
    // Override robots meta for staging environments
    const finalRobots = isStaging ? "noindex, nofollow" : robots;
    
    // Get absolute URLs for images
    const ogImage = ogimg ? getAbsoluteUrl(ogimg) : "";
    const twitterImage = "/assets/img/social/twitterimage.png";
    const absoluteTwitterImage = getAbsoluteUrl(twitterImage);
    
    // Determine canonical URL
    const finalCanonicalUrl = canonicalUrl || ogurl || window.location.href;
    
    // Generate structured data script if provided
    const structuredDataScript = structuredData 
      ? JSON.stringify(structuredData)
      : null;

    return (
      <Helmet>
          {/* HTML Lang Attribute */}
          <html lang={lang} />
          
          {/* Basic Meta Tags */}
          <title>{seotitle || storeName}</title>
          {seodescription && (
            <meta name="description" content={seodescription} />
          )}
          {keywords && (
            <meta name="keywords" content={keywords} />
          )}
          {author && (
            <meta name="author" content={author} />
          )}
          {finalRobots && (
            <meta name="robots" content={finalRobots} />
          )}
          
          {/* Canonical URL */}
          {finalCanonicalUrl && (
            <link rel="canonical" href={finalCanonicalUrl} />
          )}
          
          {/* Open Graph Tags */}
          {ogtitle && (
            <meta property="og:title" content={ogtitle} />
          )}
          {ogdescription && (
            <meta property="og:description" content={ogdescription} />
          )}
          {ogImage && (
            <meta property="og:image" content={ogImage} />
          )}
          {ogImage && ogImageWidth && (
            <meta property="og:image:width" content={ogImageWidth} />
          )}
          {ogImage && ogImageHeight && (
            <meta property="og:image:height" content={ogImageHeight} />
          )}
          {ogurl && (
            <meta property="og:url" content={ogurl} />
          )}
          <meta property="og:type" content={ogtype} />
          {storeName && (
            <meta property="og:site_name" content={storeName} />
          )}
          <meta property="og:locale" content={lang === "en" ? "en_US" : lang} />
          
          {/* Article-specific Open Graph tags */}
          {ogtype === "article" && articleAuthor && (
            <meta property="article:author" content={articleAuthor} />
          )}
          {ogtype === "article" && articlePublishedTime && (
            <meta property="article:published_time" content={articlePublishedTime} />
          )}
          {ogtype === "article" && articleModifiedTime && (
            <meta property="article:modified_time" content={articleModifiedTime} />
          )}
          
          {/* Twitter Card Tags */}
          <meta name="twitter:card" content="summary_large_image" />
          {twittertitle && (
            <meta name="twitter:title" content={twittertitle} />
          )}
          {twitterdescription && (
            <meta name="twitter:description" content={twitterdescription} />
          )}
          {twitterUsername && (
            <meta name="twitter:site" content={`@${twitterUsername}`} />
          )}
          <meta name="twitter:image" content={absoluteTwitterImage} />
          
          {/* Preconnect Links for Performance */}
          {preconnectUrls.map((url, index) => (
            <link key={`preconnect-${index}`} rel="preconnect" href={url} crossOrigin="anonymous" />
          ))}
          
          {/* Structured Data (JSON-LD) */}
          {structuredDataScript && (
            <script type="application/ld+json">
              {structuredDataScript}
            </script>
          )}
        </Helmet>
    );
  }
}

export default Meta;
